import { ConversationAddMessageExpression } from "../../../Models/Conversations/ConversationAddMessageExpression";
import { IExpressionEvaluator } from "../../../Models/IExpressionEvaluator";
import { IExpressionEvaluatorContext } from "../../../Models/IExpressionEvaluatorContext";
import { ApiServices, ApiServicesKey } from "../DomainServices/DomainServiceOperationCallExpressionEvaluator";

export class ConversationAddMessageExpressionEvaluator implements IExpressionEvaluator<ConversationAddMessageExpression> {
    get type(): string {
        return "Conversation.AddMessage";
    }

    async evaluate(expression: ConversationAddMessageExpression, context: IExpressionEvaluatorContext): Promise<string> {
        const { conversationClient, errorHandler } = context.GetProperty<ApiServices>(ApiServicesKey);

        try {
            const conversationId = await context.Evaluator.evaluate(expression.ConversationId, context);
            const message = await context.Evaluator.evaluate(expression.Message, context);
            const fileIds = expression.FileIds ? await context.Evaluator.evaluate(expression.FileIds, context) : undefined;

            const messageId = await conversationClient.addMessage(conversationId, undefined, {
                message: String(message),
                fileIds,
            });

            return messageId;
        } catch (error) {
            errorHandler(error);
            throw error;
        }
    }
}
